const searchValues = (state = {}, action) => {
    let localState = state;
    switch (action.type) {
        case 'SET_SEARCH_VALUE':
            if(action.data.value) {
                // doesn't exist - add to array
                localState[action.data.key] = action.data.value;
            } else {
                delete localState[action.data.key];
            }

            return {...localState};
        default:
            return localState;
    }
};

export default searchValues;
